import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";

import { useMediaQuery } from "react-responsive";

import { QuickRankDeck } from "../Destination";
import { useQuickRankState } from "../../../hooks/quickrank/useQuickRankState";
import {
  CARD_TO_DECK_DURATION,
  CARD_TO_DECK_SEPARATION,
  CARD_TO_HAND_DURATION,
  CARD_TO_HAND_SEPARATION,
} from "../../../constants";

import styles from "./Bottom.module.scss";

export const Bottom = () => {
  const [
    {
      configuration: { cardsPerHand },
      cards: { deck },
    },
  ] = useQuickRankState();
  const isDesktop = useMediaQuery({ query: "(min-width: 1280px)" });
  const [shouldShowBottom, setShouldShowBottom] = useState(true);

  useEffect(() => {
    if (deck.some((card) => card !== null)) {
      return;
    }

    const indexModifier = cardsPerHand - 1;
    const animationDuration =
      CARD_TO_DECK_DURATION +
      indexModifier * CARD_TO_DECK_SEPARATION +
      CARD_TO_HAND_DURATION +
      indexModifier * CARD_TO_HAND_SEPARATION;

    setTimeout(() => setShouldShowBottom(false), animationDuration * 1000);
  }, [deck]);

  return (
    <AnimatePresence>
      {shouldShowBottom && (
        <motion.div
          className={styles.quickRankBottom}
          exit={{
            bottom: isDesktop ? "-320px" : "-200px",
            transition: {
              duration: 0.5,
            },
          }}
        >
          <QuickRankDeck />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
